import TextUtil from 'util/TextUtil';

export const buildNavItemEventData = ({ node, type }) => ({
  menu_item: TextUtil.toAllUpperCase(node.title),
  section: TextUtil.toAllUpperCase(type),
  node_level_1: TextUtil.toAllUpperCase(type === 'Primary' ? node.title : node.parent),
  row_position: 1,
  column_position: node.position,
});

const getSubMenuNodeLevel1 = ({ parent, grandparent, type }) => {
  if (type === 'Primary') return parent.title;
  // if a grandparent exists - this is a MultiColumn dropdown
  if (grandparent) return grandparent.parent;
  return parent.parent;
};

const getSubMenuNodeLevel2 = ({ parent, grandparent, type }) => {
  if (type === 'Primary') return undefined;
  // if a grandparent exists - this is a MultiColumn dropdown
  if (grandparent) return TextUtil.toAllUpperCase(grandparent.title);
  return TextUtil.toAllUpperCase(parent.title);
};

export const buildNavSubMenuEventData = ({ parent, child, type, index, grandparent }) => ({
  menu_item: TextUtil.toAllUpperCase(child.title),
  section: TextUtil.toAllUpperCase(`${type}_SUB_MENU`),
  node_level_1: TextUtil.toAllUpperCase(getSubMenuNodeLevel1({ parent, grandparent, type })),
  node_level_2: getSubMenuNodeLevel2({ parent, grandparent, type }),
  row_position: index + 1,
  column_position: parent.position || 1,
});

export const NAV_SECTIONS = {
  promotional: 'PROMOTIONAL',
  utility: 'UTILITY',
  primary: 'PRIMARY',
  secondary: 'SECONDARY',
  tertiary: 'TERTIARY',
  footer: 'FOOTER',
  primarySubNav: 'PRIMARY_SUB_MENU',
  secondarySubNav: 'SECONDARY_SUB_MENU',
  promotionalSubNav: 'PROMOTIONAL_SUB_MENU',
  utilitySubNav: 'UTILITY_SUB_MENU',
  minimal: 'MINIMAL',
};

NAV_SECTIONS.all = [
  NAV_SECTIONS.promotional,
  NAV_SECTIONS.utility,
  NAV_SECTIONS.primary,
  NAV_SECTIONS.secondary,
  NAV_SECTIONS.tertiary,
  NAV_SECTIONS.footer,
  NAV_SECTIONS.primarySubNav,
  NAV_SECTIONS.secondarySubNav,
  NAV_SECTIONS.promotionalSubNav,
  NAV_SECTIONS.utilitySubNav,
  NAV_SECTIONS.minimal,
];
